export function illegalContent() {
    const directiveCheck = document.querySelector("[name='dyrektywa']");
    if (directiveCheck) {
        const nameInput = document.querySelector(".dyrektywa--imie").querySelector("[name='IMIE']");
        const emailInput = document.querySelector(".dyrektywa--email").querySelector("[name='ADRES_E_MAIL']");
        const starsRequired = document.querySelectorAll(".dyrektywa--required");
         directiveCheck.addEventListener("click", () => {
            starsRequired.forEach(star => {
                star.style.display = "none";
            })
            if (directiveCheck.checked && nameInput && emailInput) {
                nameInput.parentNode.classList.add('checked');
                emailInput.parentNode.classList.add('checked');
                emailInput.parentNode.classList.remove("has-error");
                nameInput.parentNode.classList.remove("has-error");
                nameInput.removeAttribute("data-required");
                nameInput.removeAttribute("required");
                nameInput.setAttribute("disabled", "");
                nameInput.setAttribute("aria-required", "false");
                nameInput.setAttribute("disabled", '');
                emailInput.removeAttribute("required");
                emailInput.removeAttribute("data-required");
                emailInput.setAttribute("aria-required", "false");
                starsRequired.forEach(star => {
                    star.style.display = "none";
                })
                // console.log(nameInput, emailInput);
            } else if (nameInput && emailInput) {
                nameInput.parentNode.classList.remove('checked');
                emailInput.parentNode.classList.remove('checked');
                nameInput.dataset.required = "text";
                nameInput.setAttribute("aria-required", "true");
                nameInput.setAttribute("required", "required");
                nameInput.removeAttribute("disabled");
                emailInput.dataset.required = "text";
                emailInput.setAttribute("aria-required", "true");
                emailInput.setAttribute("required", "required");
                starsRequired.forEach(star => {
                    star.style.display = "inline-block";
                })
            }
        });
    }

    let crimeInputs = document.querySelectorAll("[name='rodzaj']");
    const crimeInputToSend = document.querySelector("[name='CRIME']");
    if (crimeInputs && crimeInputToSend) {
        crimeInputs = [...crimeInputs];
        let crimeInputsArr = [];
        // console.log("BEFORE", crimeInputs, "crimeInputToSend.value", crimeInputToSend.value);
         crimeInputs.forEach(inp => {
            inp.addEventListener("click", () => {
                if (inp.checked) {
                    crimeInputsArr.push(`${inp.value}`);
                } else {
                    const ind = crimeInputsArr.indexOf(`${inp.value}`);
                    crimeInputsArr.splice(ind, 1)
                }
                crimeInputToSend.value = crimeInputsArr.join(", ");
                // console.log(crimeInputsArr, "crimeInputToSend.value", crimeInputToSend.value);
            })
         });

    }
}